export default __webpack_public_path__ + "static/media/venture-welcome.cefbc09e.jpg";